import BaseViz from './BaseViz'
import ScatterPlotChart from '../charts/ScatterPlotChart'
import ScatterDataController from '../viz_behaviors/ScatterDataController'
import { select as d3_select } from 'd3-selection'
import {
  drawSvgCircle,
  drawSvgPlus,
  drawSvgPolygon,
  drawSvgSquare,
  drawSvgStar,
  drawSvgTriangle,
} from '../utils/shapeUtils'
export default class ScatterPlotViz extends BaseViz {
  static defaultConfig = {
    sizeAttr: null,
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'], //['sequential2','sequential3','categorical']
        nonEditable: true,
      },
      colorKey: 'group',
    },
    AxisHelper: {
      x: {
        showTickValues: {
          nonEditable: true,
        },
        tickMatchData: {
          nonEditable: true,
          exposed: false,
        },
      },
    },
    TooltipBehavior: {
      getHtml: function (d) {
        let iconShape = 'circle'

        if (
          this.config.ItemsHelper.colorDict &&
          this.config.ItemsHelper.colorDict[d.group]?.shape
        ) {
          iconShape = this.config.ItemsHelper.colorDict[d.group]?.shape
        }
        let drawShapeEnterCb, drawShapeMergeCb
        const SHAPES_DEFAULT_SIZE = 9
        switch (iconShape) {
          case 'circle':
            drawShapeEnterCb = sel => drawSvgCircle(sel, 0, 'enter')
            drawShapeMergeCb = sel => drawSvgCircle(sel, SHAPES_DEFAULT_SIZE / 2, 'edit')
            break
          case 'square':
            drawShapeEnterCb = sel => drawSvgSquare(sel, 0, 'enter')
            drawShapeMergeCb = sel => drawSvgSquare(sel, SHAPES_DEFAULT_SIZE, 'edit')
            break
          case 'triangle':
            drawShapeEnterCb = sel => drawSvgTriangle(sel, 0, 'enter')
            drawShapeMergeCb = sel => drawSvgTriangle(sel, SHAPES_DEFAULT_SIZE, 'edit')
            break
          case 'fivePointStar':
            drawShapeEnterCb = sel => drawSvgStar(sel, 0, 5, 'enter')
            drawShapeMergeCb = sel => drawSvgStar(sel, SHAPES_DEFAULT_SIZE, 5, 'edit')
            break
          case 'sixPointStar':
            drawShapeEnterCb = sel => drawSvgStar(sel, 0, 6, 'enter')
            drawShapeMergeCb = sel => drawSvgStar(sel, SHAPES_DEFAULT_SIZE, 6, 'edit')
            break
          case 'hexagon':
            drawShapeEnterCb = sel => drawSvgPolygon(sel, 0, 6, 'enter')
            drawShapeMergeCb = sel => drawSvgPolygon(sel, SHAPES_DEFAULT_SIZE, 6, 'edit')
            break
          case 'pentagon':
            drawShapeEnterCb = sel => drawSvgPolygon(sel, 0, 5, 'enter')
            drawShapeMergeCb = sel => drawSvgPolygon(sel, SHAPES_DEFAULT_SIZE, 5, 'edit')
            break
          case 'plus':
            drawShapeEnterCb = sel => drawSvgPlus(sel, SHAPES_DEFAULT_SIZE, 'enter')
            drawShapeMergeCb = sel => drawSvgPlus(sel, SHAPES_DEFAULT_SIZE, 'edit')
            break
          default:
            drawShapeEnterCb = sel => drawSvgCircle(sel, SHAPES_DEFAULT_SIZE / 2, 'enter')
            drawShapeMergeCb = sel => drawSvgCircle(sel, SHAPES_DEFAULT_SIZE / 2, 'edit')
        }

        const drawIcon = () => {
          let svgShape = d3_select('#tip-icon')
            .selectAll('svg')
            .data([d], dd => dd.id)
          const svgShapeEnter = svgShape.enter().append('svg').attr('width', 9).attr('height', 9)
          svgShape.exit().remove()
          svgShape = svgShape.merge(svgShapeEnter)

          let shapes = svgShape.selectAll(`.${iconShape}`).data([d], dd => dd.id)
          const shapesEnter = shapes
            .enter()
            .append('g')
            .attr('class', iconShape)
            .attr('stroke-width', 0)
          shapesEnter.call(drawShapeEnterCb)
          shapesEnter /*.select(`.${className}`)*/
            .style('transform', 'translate(50%, 50%)')
          shapes.exit().remove()
          shapes = shapes.merge(shapesEnter)
          shapes
            .attr('fill', d => this.color(d), SHAPES_DEFAULT_SIZE)
            .attr('stroke', d => this.color(d), SHAPES_DEFAULT_SIZE)
            .call(drawShapeMergeCb)
        }

        function checkForElement() {
          const tipIcon = document.getElementById('tip-icon')
          if (tipIcon) {
            drawIcon()
          } else {
            requestAnimationFrame(checkForElement)
          }
        }

        return `
        <div class="tip-value important">${d.id}</div>
        <div class="tip-id">
          x: ${this.formatTooltipValue(d.x, 'x')} | y: ${this.formatTooltipValue(d.y, 'y')}
        </div>
        <div class="secondary" style="display: flex; align-items: center; justify-content: center; gap: 3px">
          <div id="tip-icon" class="icon">
            <script>
              ${requestAnimationFrame(checkForElement)}
            </script>
          </div>
          <div>
          ${d.group}
          </div>
        </div>
        `
      },
      getItemOffset: function ($el, d) {
        let targetRect = d3_select($el).select('.point-shape').node().getBoundingClientRect()
        return {
          x: targetRect.x + targetRect.width / 2,
          y: targetRect.y + targetRect.height / 2, //- 10
        }
      },
    },
    LegendBehavior: {
      icon: 'circle',
    },
  }
  static chartClass = ScatterPlotChart
  static dataControllerClass = ScatterDataController
}
